// searchConstants.js
'use strict';

export const searchType = {
  ALL: 'all',
  FLIX: 'flix',
  SWAGGER: 'swagger',
  STORY: 'story',
  HASHTAG: 'hashtag',
};

export const searchSwaggerCategoryPath = {
  ONLINE: 'online',
  NEW: 'new',
};

export const searchTypeArray = [
  searchType.ALL,
  searchType.FLIX,
  searchType.SWAGGER,
  searchType.STORY,
  // searchType.HASHTAG,
];

export const searchPageTDKTranslateKeys = {
  [searchType.ALL]: {
    title: 'seo_search_all_title',
    description: 'seo_search_all_description',
  },
  [searchType.FLIX]: {
    title: 'seo_search_video_title',
    description: 'seo_search_video_description',
  },
  [searchType.STORY]: {
    title: 'seo_search_stories_title',
    description: 'seo_search_stories_description',
  },
  [searchType.SWAGGER]: {
    title: 'seo_search_swagger_title',
    description: 'seo_search_swagger_description',
  },
  [searchType.HASHTAG]: {
    title: 'seo_search_hashtag_title',
    description: 'seo_search_hashtag_description',
  },
  default: {
    title: 'seo_search_all_title',
    description: 'seo_search_all_description',
  },
};

export const MAX_RECENT_SEARCH = 5;
export const SEARCH_SUGGESTIONS_RECENT_LIMIT = 4;
export const SEARCH_SUGGESTIONS_TOTAL_LIMIT = 8;
export const SEARCH_SUGGESTIONS_RECENT_SEARCH = 'recent_searches';
export const SEARCH_SUGGESTIONS_POPULAR_SEARCH = 'popular_searches';
export const AUTO_COMPLETE_MODAL_ROOT_ID = 'SearchBarAutoCompleteModalRoot';
export const AUTO_COMPLETE_MODAL_ID = 'SearchBarAutoCompleteModal';
export const SEARCH_MODAL_ID = 'SearchModal';
